module.exports = __webpack_public_path__ + "images/emoji/fuelpump.a471fa3a5d9e27886800.png";